module.exports = __webpack_public_path__ + "img/website-service-05.d88ccdf9.png";